import * as React from "react";
import { createRoot } from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import Dashboard from './Pages/Dashboard'
import './index.css'
import Header from "./components/Header";
import Footer from "./components/Footer";
import PickDate from "./Pages/PickDate";
import SelectRide from "./Pages/SelectRide";
import Checkout from "./Pages/Checkout";
import Admin from './Pages/Admin'
import Login from './Pages/Login'
import { Toaster } from 'react-hot-toast';
import { Provider } from "react-redux";
import { store } from "./redux/store";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/pickDate",
    element: <PickDate />,
  },
  {
    path: "/selectRide",
    element: <SelectRide />,
  },
  {
    path: "/checkout",
    element: <Checkout />,
  },
  {
    path: "/admin",
    element: <Admin />,
  },
  {
    path: "/login",
    element: <Login />,
  },
])

createRoot(document.getElementById("root")).render(<>
  <Provider store={store()}>
    <Header />
    <RouterProvider router={router} />
    <Toaster />
    <Footer />
  </Provider>
</>
)